import * as Yup from 'yup';
import i18next from '../i18n';
import { formatMoneyNumeral } from '../util/helpers/numeralHelpers';

export const wireWithdrawalValidationSchema = (isImpersonating, maxAmount) => {
  const amount = Yup.number()
    .required(i18next.t('validationSchema.general.amountRequired'))
    .min(
      0.01,
      i18next.t('validationSchema.withdrawal.withdrawalMinAmount', {
        amount: formatMoneyNumeral(0.01),
      }),
    )
    .max(maxAmount, i18next.t('validationSchema.general.insufficientFunds'));

  if (isImpersonating) {
    return Yup.object().shape({
      amount,
      wireWithdrawalFeeCredit: Yup.number()
        .required(
          i18next.t(
            'validationSchema.withdrawal.wireWithdrawalFeeCreditRequired',
          ),
        )
        .min(
          0,
          i18next.t('validationSchema.withdrawal.withdrawalMinAmount', {
            amount: formatMoneyNumeral(0),
          }),
        )
        .max(25, i18next.t('validationSchema.general.insufficientFunds'))
        .test(
          'combined-total',
          i18next.t('validationSchema.general.insufficientFunds'),
          // eslint-disable-next-line func-names
          function (wireWithdrawalFeeCredit) {
            const { amount = 0 } = this.parent;
            return amount + wireWithdrawalFeeCredit <= maxAmount;
          },
        ),
    });
  }

  return Yup.object().shape({
    amount,
  });
};
